module.exports = __webpack_public_path__ + "static/media/game_cover_slidey@768.08e2724e.png";